import Vue from 'vue'
import Vuex from 'vuex'
import ph from './ph'
import tn from './tn'
import ks from './ks'
import se from './se'
import ku from './ku'
import vo from './vo'
import structure from './structure'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeStep: 0,
    testCompleted: false,
    text0: "Technisch/ Naturwissenschaftlich:",
    text1: "Praktisch Handwerklich:",
    text2: "Kreativ/ Sprachlich:",
    text3: "Sozialpflegerisch/ Erzieherisch:",
    text4: "Kaufmännisch/ Unternehmerisch:",
    text5: "Verwaltend/ Ordnend:",
    link0: "101",
    link1: "100",
    link2: "102",
    link3: "103",
    link4: "104",
    link5: "105",
    pph: '',
    ptn: '',
    pks: '',
    pse: '',
    pvo: '',
    pku: '',
    tmp: null,
    temp: null,
    templink: 0,
    temppct: 0,
    pct1: 0,
    pct2: 0,
    pct3: 0,
    pct4: 0,
    pct5: 0,
    pct0: 0,
    // pph1: 0,
    // ptn1: 0,
    // pks1: 0,
    // pse1: 0,
    // pvo1: 0,
    // pku1: 0,
    regions: {
      ...ph,
      ...tn,
      ...ks,
      ...se,
      ...ku,
      ...vo,
    },
    structure,
    user: {
      name: '',
      age: null,
      gender: '',
      email: '',
      school: '',
      year: '',
    },
  },
  getters: {
    activeQuestion: state => {
      return state.structure[state.activeStep] || null
    },
    userCompleted: ({ user, }) => {
      if (user.name && user.age && user.gender && user.email && user.age && user.school && user.year) {
        return true
      }
      return false
    },
    allSteps: state => {
      return Object.keys(state.structure).length
    },
  },
  mutations: {
    updateName(state, val) {
      state.user.name = val
    },
    updateEmail(state, val) {
      state.user.email = val
    },
    updateGender(state, val) {
      state.user.gender = val
    },
    updateAge(state, val) {
      state.user.age = val
    },
    updateSchool(state, val) {
      state.user.school = val
    },
    updateYear(state, val) {
      state.user.year = val
    },
    incrementStep(state) {
      state.activeStep++
    },
    decrementStep(state) {
      state.activeStep--
    },
    dislikeItem(state, id) {
      state.structure[state.activeStep].dislike = id
    },
    likeItem(state, id) {
      state.structure[state.activeStep].like = id
    },
    setTestCompleted(state) {
      state.testCompleted = true
    },
    setErrors(state, errors) {
      console.log(errors)
    },
  },
  actions: {
    updateUser({ commit, }, input) {
      if (input.name === 'name') return commit('updateName', input.value)
      if (input.name === 'email') return commit('updateEmail', input.value)
      if (input.name === 'gender') return commit('updateGender', input.value)
      if (input.name === 'age') return commit('updateAge', input.value)
      if (input.name === 'school') return commit('updateSchool', input.value)
      if (input.name === 'year') return commit('updateYear', input.value)
    },
    handlePrevClick({ commit, getters, state, }) {
      return commit('decrementStep')
    },
    handleNextClick({ commit, dispatch, getters, state, }) {
      // if (Object.keys(state.structure).length === state.activeStep && getters.userCompleted) return dispatch('sendFormData')
      if (Object.keys(state.structure).length === state.activeStep && !getters.userCompleted) return dispatch('sendFormData')
      return commit('incrementStep')
    },
    pdfcreate({ commit, getters, state, }){
      const data = new FormData()
      data.append('link0', state.link0)
      data.append('link1', state.link1)
      data.append('link2', state.link2)
      data.append('link3', state.link3)
      data.append('link4', state.link4)
      data.append('link5', state.link5)
      data.append('text0', state.text0)
      data.append('text1', state.text1)
      data.append('text2', state.text2)
      data.append('text3', state.text3)
      data.append('text4', state.text4)
      data.append('text5', state.text5)
      data.append('persent0', state.ptn)
      data.append('persent1', state.pph)
      data.append('persent2', state.pks)
      data.append('persent3', state.pse)
      data.append('persent4', state.pku)
      data.append('persent5', state.pvo)
      //console.log(data);
      axios({
        method: 'post',
        url: '/basis-check/form/rechnung.php',
        data,
        responseType: 'blob',
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));

          var fileLink = document.createElement('a');
     
       
     
          fileLink.href = fileURL;
     
          fileLink.setAttribute('download', 'basis-check-berufswahl-ergebnisse.pdf');
     
          document.body.appendChild(fileLink);
     
        
     
          fileLink.click();
          // return commit('setTestCompleted')
        })
        .catch(err => {
          // const errors = err.response.data
          // console.log(err)
          // console.log(err.response)
          // return commit('setErrors', errors)
        })
    },
    sendFormData({ commit, getters, state, }) {
      let likes = []
      let dislikes = []

      let ksTotal = 0
      let kuTotal = 0
      let phTotal = 0
      let seTotal = 0
      let tnTotal = 0
      let voTotal = 0

      const calcTotal = (string, operation) => {
        if (string === 'ks' && operation === 'plus') return ksTotal++
        if (string === 'ks' && operation === 'minus') return ksTotal--

        if (string === 'ku' && operation === 'plus') return kuTotal++
        if (string === 'ku' && operation === 'minus') return kuTotal--

        if (string === 'ph' && operation === 'plus') return phTotal++
        if (string === 'ph' && operation === 'minus') return phTotal--

        if (string === 'se' && operation === 'plus') return seTotal++
        if (string === 'se' && operation === 'minus') return seTotal--

        if (string === 'tn' && operation === 'plus') return tnTotal++
        if (string === 'tn' && operation === 'minus') return tnTotal--

        if (string === 'vo' && operation === 'plus') return voTotal++
        if (string === 'vo' && operation === 'minus') return voTotal--
      }

      for (const key in state.structure) {
        if (state.structure.hasOwnProperty(key)) {
          const like = state.structure[key].like
          const dislike = state.structure[key].dislike
          likes.push(like)
          dislikes.push(dislike)

          calcTotal(like.substring(0, 2), 'plus')
          calcTotal(dislike.substring(0, 2), 'minus')
        }
      }

      state.pct1= phTotal
      state.pct0= tnTotal
      state.pct2= ksTotal
      state.pct3= seTotal
      state.pct5= voTotal
      state.pct4= kuTotal

      

      const data = new FormData()
      data.append('name', state.user.name)
      data.append('age', state.user.age)
      data.append('email', state.user.email)
      data.append('school', state.user.school)
      data.append('gender', state.user.gender)
      data.append('year', state.user.year)
      data.append('likes', likes.join(', '))
      data.append('dislikes', dislikes.join(', '))
      data.append('ksTotal', ksTotal)
      data.append('kuTotal', kuTotal)
      data.append('phTotal', phTotal)
      data.append('seTotal', seTotal)
      data.append('tnTotal', tnTotal)
      data.append('voTotal', voTotal)

      axios({
        method: 'post',
        url: '/basis-check/form/form.php',
        data,
      })
        .then(res => {
          console.log(res.data['ks']['ks'])
          state.ptn = res.data['tn']['tn']
          state.pph = res.data['ph']['ph']
          state.pks = res.data['ks']['ks']
          state.pse = res.data['se']['se']
          state.pku = res.data['ku']['ku']
          state.pvo = res.data['vo']['vo']
          
          if(state.ptn<state.pph){
            state.tmp=state.ptn
            state.ptn=state.pph
            state.pph=state.tmp
            state.temp=state.text0
            state.text0=state.text1
            state.text1=state.temp
            state.templink=state.link0
            state.link0=state.link1
            state.link1=state.templink
            state.temppct=state.pct0
            state.pct0=state.pct1
            state.pct1=state.temppct
          }
          if(state.ptn<state.pks){
            state.tmp=state.ptn
            state.ptn=state.pks
            state.pks=state.tmp
            state.temp=state.text0
            state.text0=state.text2
            state.text2=state.temp
            state.templink=state.link0
            state.link0=state.link2
            state.link2=state.templink
            state.temppct=state.pct0
            state.pct0=state.pct2
            state.pct2=state.temppct
          }
          if(state.ptn<state.pse){
            state.tmp=state.ptn
            state.ptn=state.pse
            state.pse=state.tmp
            state.temp=state.text0
            state.text0=state.text3
            state.text3=state.temp
            state.templink=state.link0
            state.link0=state.link3
            state.link3=state.templink
            state.temppct=state.pct0
            state.pct0=state.pct3
            state.pct3=state.temppct
          }
          if(state.ptn<state.pku){
            state.tmp=state.ptn
            state.ptn=state.pku
            state.pku=state.tmp
            state.temp=state.text0
            state.text0=state.text4
            state.text4=state.temp
            state.templink=state.link0
            state.link0=state.link4
            state.link4=state.templink
            state.temppct=state.pct0
            state.pct0=state.pct4
            state.pct4=state.temppct
          }
          if(state.ptn<state.pvo){
            state.tmp=state.ptn
            state.ptn=state.pvo
            state.pvo=state.tmp
            state.temp=state.text0
            state.text0=state.text5
            state.text5=state.temp
            state.templink=state.link0
            state.link0=state.link5
            state.link5=state.templink
            state.temppct=state.pct0
            state.pct0=state.pct5
            state.pct5=state.temppct
          }

          if(state.pph<state.pks){
            state.tmp=state.pph
            state.pph=state.pks
            state.pks=state.tmp
            state.temp=state.text1
            state.text1=state.text2
            state.text2=state.temp
            state.templink=state.link1
            state.link1=state.link2
            state.link2=state.templink
            state.temppct=state.pct1
            state.pct1=state.pct2
            state.pct2=state.temppct
          }
          if(state.pph<state.pse){
            state.tmp=state.pph
            state.pph=state.pse
            state.pse=state.tmp
            state.temp=state.text1
            state.text1=state.text3
            state.text3=state.temp
            state.templink=state.link1
            state.link1=state.link3
            state.link3=state.templink
            state.temppct=state.pct1
            state.pct1=state.pct3
            state.pct3=state.temppct
          }
          if(state.pph<state.pku){
            state.tmp=state.pph
            state.pph=state.pku
            state.pku=state.tmp
            state.temp=state.text1
            state.text1=state.text4
            state.text4=state.temp
            state.templink=state.link1
            state.link1=state.link4
            state.link4=state.templink
            state.temppct=state.pct1
            state.pct1=state.pct4
            state.pct4=state.temppct
          }
          if(state.pph<state.pvo){
            state.tmp=state.pph
            state.pph=state.pvo
            state.pvo=state.tmp
            state.temp=state.text1
            state.text1=state.text5
            state.text5=state.temp
            state.templink=state.link1
            state.link1=state.link5
            state.link5=state.templink
            state.temppct=state.pct1
            state.pct1=state.pct5
            state.pct5=state.temppct
          }

          if(state.pks<state.pse){
            state.tmp=state.pks
            state.pks=state.pse
            state.pse=state.tmp
            state.temp=state.text2
            state.text2=state.text3
            state.text3=state.temp
            state.templink=state.link2
            state.link2=state.link3
            state.link3=state.templink
            state.temppct=state.pct2
            state.pct2=state.pct3
            state.pct3=state.temppct
          }
          if(state.pks<state.pku){
            state.tmp=state.pks
            state.pks=state.pku
            state.pku=state.tmp
            state.temp=state.text2
            state.text2=state.text4
            state.text4=state.temp
            state.templink=state.link2
            state.link2=state.link4
            state.link4=state.templink
            state.temppct=state.pct2
            state.pct2=state.pct4
            state.pct4=state.temppct
          }
          if(state.pks<state.pvo){
            state.tmp=state.pks
            state.pks=state.pvo
            state.pvo=state.tmp
            state.temp=state.text2
            state.text2=state.text5
            state.text5=state.temp
            state.templink=state.link2
            state.link2=state.link5
            state.link5=state.templink
            state.temppct=state.pct2
            state.pct2=state.pct5
            state.pct5=state.temppct
          }

          if(state.pse<state.pku){
            state.tmp=state.pse
            state.pse=state.pku
            state.pku=state.tmp
            state.temp=state.text3
            state.text3=state.text4
            state.text4=state.temp
            state.templink=state.link3
            state.link3=state.link4
            state.link4=state.templink
            state.temppct=state.pct3
            state.pct3=state.pct4
            state.pct4=state.temppct
          }
          if(state.pse<state.pvo){
            state.tmp=state.pse
            state.pse=state.pvo
            state.pvo=state.tmp
            state.temp=state.text3
            state.text3=state.text5
            state.text5=state.temp
            state.templink=state.link3
            state.link3=state.link5
            state.link5=state.templink
            state.temppct=state.pct3
            state.pct3=state.pct5
            state.pct5=state.temppct
          }

          if(state.pku<state.pvo){
            state.tmp=state.pku
            state.pku=state.pvo
            state.pvo=state.tmp
            state.temp=state.text4
            state.text4=state.text5
            state.text5=state.temp
            state.templink=state.link4
            state.link4=state.link5
            state.link5=state.templink
            state.temppct=state.pct4
            state.pct4=state.pct5
            state.pct5=state.temppct
          }
          return commit('setTestCompleted')
        })
        .catch(err => {
          const errors = err.response.data
          console.log(err)
          console.log(err.response)
          return commit('setErrors', errors)
        })

      return console.log('Lets send dis shit!')
    },
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js